import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const SERVICES = [
  {
    num: "S/01",
    title: "EVENT COVERAGE",
    desc: "Full-event film and photo units for race meetings, time attack rounds and showcases — trackside, pit lane and paddock.",
    bullets: ["Multi-camera cinema units", "Same-day social cutdowns", "Full event film + stills library"],
    intent: "Event Coverage",
  },
  {
    num: "S/02",
    title: "BRAND & LAUNCH FILMS",
    desc: "Hero films for automotive brands, tuning shops and builds — from concept and storyboard through to final grade and mix.",
    bullets: ["Concept + storyboard", "Motion control & car rigs", "Licensed music + sound design"],
    intent: "Commercial Film",
  },
  {
    num: "S/03",
    title: "AUTOMOTIVE PHOTOGRAPHY",
    desc: "High-impact stills — rolling shots, detail studies and event galleries, retouched and delivered publication-ready.",
    bullets: ["Rolling & rig shots", "Detail / macro studies", "Full gallery delivery"],
    intent: "Photography",
  },
  {
    num: "S/04",
    title: "POST & COLOUR",
    desc: "The edit is where the lap time is made. Cinema-grade grading, sound mix and delivery for every screen the brief demands.",
    bullets: ["HDR cinema grade", "Broadcast + social masters", "Fast turnaround"],
    intent: "Post & Colour",
  },
];

export default function Services({ onDiscuss }) {
  return (
    <section id="services" data-testid="services-section" className="relative bg-surface py-24 md:py-36">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex items-end justify-between mb-14 md:mb-20">
            <div>
              <p className="font-mono text-[10px] tracking-[0.4em] text-signal mb-4">03 — SERVICES</p>
              <h2
                className="font-display text-5xl md:text-7xl text-white leading-[0.95]"
                style={{ fontWeight: 900 }}
              >
                PADDOCK TO <span className="text-outline">POST</span>
              </h2>
            </div>
            <p className="hidden md:block font-mono text-[11px] tracking-[0.25em] text-smoke text-right">
              FOUR DISCIPLINES — ONE CREW
              <br />
              <span className="text-white/50">SCOPED LIKE TELEMETRY, SHOT LIKE CINEMA</span>
            </p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.num} delay={(i % 2) * 0.06} className="h-full">
              <div
                data-testid={`service-card-${i + 1}`}
                className="group relative h-full flex flex-col border border-white/10 bg-ink/60 p-8 md:p-10 hover:border-signal/70 hover:-translate-y-1.5 transition-all duration-500 overflow-hidden"
              >
                <span
                  className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                  style={{
                    background:
                      "radial-gradient(120% 90% at 50% 0%, rgba(255,42,42,0.16), transparent 60%)",
                    boxShadow:
                      "inset 0 0 60px rgba(255,42,42,0.12), 0 0 44px rgba(255,42,42,0.2)",
                  }}
                />
                <span className="absolute left-0 top-0 h-full w-[2px] bg-signal scale-y-0 group-hover:scale-y-100 origin-top transition-transform duration-500" />
                <span className="font-mono text-xs tracking-[0.3em] text-signal group-hover:[text-shadow:0_0_14px_rgba(255,42,42,0.9)] transition-all duration-500">{s.num}</span>
                <h3
                  className="font-display text-3xl md:text-4xl text-white group-hover:text-signal transition-colors duration-300 mt-3 mb-4"
                  style={{ fontWeight: 800 }}
                >
                  {s.title}
                </h3>
                <p className="text-smoke text-sm md:text-base font-light leading-relaxed mb-6">
                  {s.desc}
                </p>

                <ul className="space-y-2.5 mb-8">
                  {s.bullets.map((b) => (
                    <li key={b} className="font-mono text-[11px] tracking-[0.2em] text-white/75 flex items-center gap-3">
                      <span className="w-1.5 h-1.5 bg-signal rotate-45 shrink-0" />
                      {b}
                    </li>
                  ))}
                </ul>

                <button
                  data-testid={`service-discuss-${i + 1}`}
                  onClick={() => onDiscuss(s.intent)}
                  className="mt-auto inline-flex items-center gap-3 self-start font-mono text-[11px] tracking-[0.25em] text-white/80 hover:text-signal transition-colors duration-300 link-sweep"
                >
                  DISCUSS THIS SERVICE
                  <ArrowRight
                    size={14}
                    className="group-hover:translate-x-1 transition-transform duration-300"
                  />
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
